import axios from 'axios';

const SERVER_URL = "https://integdeploy-back.vercel.app";

// Fonction pour obtenir tous les utilisateurs
export const getAllUsers = async () => {
  try {
    const response = await axios.get(`${SERVER_URL}/users`);
    return response.data.users;
  } catch (error) {
    console.error("Erreur lors de la récupération des utilisateurs :", error);
    throw error;
  }
};

// Fonction pour créer un nouvel utilisateur
export const createUser = async (userData) => {
  try {
    const response = await axios.post(`${SERVER_URL}/users`, userData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création de l'utilisateur :", error);
    if (error.response) {
      console.error("Détails de l'erreur :", error.response.data);
    }
    throw error;
  }
};


// Fonction pour compter les utilisateurs
export const countUsers = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/users`);
      if (response.data && response.data.users) {
        return response.data.users.length;
      }
      throw new Error("Invalid API response");
    } catch (error) {
      console.error("Erreur lors du comptage des utilisateurs :", error);
      throw error;
    }
  };

// Fonction pour se connecter
export const loginUser = async (credentials) => {
  try {
    const response = await axios.post(`${SERVER_URL}/users/login`, credentials, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la connexion :", error);
    if (error.response) {
      console.error("Détails de l'erreur :", error.response.data);
    }
    throw error;
  }
};

//Fonction pour supprimer un utilisateur via son ID
export const deleteUser = async (userId) => {
  try {
    const response = await fetch(`${SERVER_URL}/users/${userId}`, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}` // Ajoute le token d'authentification
      }
    });

    if (!response.ok) {
      throw new Error("Erreur lors de la suppression de l'utilisateur");
    }
  } catch (error) {
    console.error("Erreur lors de la suppression de l'utilisateur :", error);
    throw error;
  }
};
